// extracted by mini-css-extract-plugin
export default {"popup":"subscription_popup__UxQA5","modalWrap":"subscription_modalWrap__ysoKb","bd":"subscription_bd__K25ec"};